<!-- container-xxl -->
<style>
    .innovative_projects_design{background: #00a2e2;
        color: #ffffff;
        padding: 20px;
        font-size: 20px;
        border-radius: 8px; display: block;}
    .innovative_projects_design i{background: white;
        padding: 10px 20px;
        font-size: 30px;
        border-radius: 50%; color: #00a2e2;}
    </style>
    <div class="content-wrapper aboutus-content-wrapper-container p-0 content-aboutus-outer-container">
        <app-content-header [contentHeader]="contentHeader"></app-content-header>
        <!-- <div class="content-body content-body-outer-img-container">
          <img src="assets\images\about-us-img\Group 158.png" alt="about-us">
        </div> -->
        <div class="content-body">
          <!-- app e-commerce details start -->
        
            <div class="container">
                <div class="row">
                    <div class="col-xl-4 col-md-6 col-12 " style="padding: 15px;">
                        <a   routerLink="/my-application"  class="innovative_projects_design"> <i class="fa-solid fa-caret-right"></i> Submitted Applications
                        </a>
                    </div>
    
                    <div class="col-xl-4 col-md-6 col-12 " style="padding: 15px;">
                        <a  routerLink="/hydrogen-energy-application"  class="innovative_projects_design"> <i class="fa-solid fa-caret-right"></i> Hydrogen Energy Applications</a>
                    </div>
    
                   
    
                   
                </div>
               
    
                
    
            </div>
        </div>
      </div>